import { CancellationToken } from "async/CancellationToken";
import { PurchaseHistory } from "../../marketplace/main/models/building/PurchaseHistory";

export class ShowEditPriceSceneParams {
    public readonly buildingId: string;
    public readonly tokenId: string;
    public readonly currentPrice: number;
    public readonly isAddToMarketplace: boolean;
    public readonly orderId: string;
    public readonly purchaseHistory: Array<PurchaseHistory>;
    public readonly cancellationToken: CancellationToken;

    public constructor(
        buildingId: string,
        tokenId: string,
        currentPrice: number,
        isAddToMarketplace: boolean,
        orderId: string,
        purchaseHistory: Array<PurchaseHistory>,
        cancellationToken: CancellationToken
    ) {
        this.buildingId = buildingId;
        this.tokenId = tokenId;
        this.currentPrice = currentPrice;
        this.isAddToMarketplace = isAddToMarketplace;
        this.orderId = orderId;
        this.purchaseHistory = purchaseHistory;
        this.cancellationToken = cancellationToken;
    }
}
